// Module
var code = "<div class=\"contact-address-table-scenario\"> <table-list table-title=\"{{vm.addressTitle}}\" grid-template=\"vm.gridTemplate\" column-header=\"vm.columnHeader\" column-content=\"vm.columnContent\" edit-handler=\"vm.editHandler\" delete-handler=\"vm.deleteHandler\"> </table-list> </div> ";
// Exports
module.exports = code;